import { Dialog, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import React from "react";

// This view is intended to land inside Dialog component, which requires open and onChange props to work properly
export const DialogViewContainer = ({ children }: any) => {
  return <>{children}</>;
};

export const DialogTitleContainer = ({ children }: any) => {
  return (
    <>
      <DialogTitle>{children}</DialogTitle>
      <Divider />
    </>
  );
};

export const DialogContentContainer = ({ children }: any) => {
  return <DialogContent style={{ maxWidth: 800 }}>{children}</DialogContent>;
};

export interface AddTreeBlockDialogProps extends React.ComponentProps<any> {
  onCancel: () => void;
  open: boolean;
}

export const DialogComponent = (props: AddTreeBlockDialogProps) => {
  const { open, children, onCancel } = props;

  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth={true}
      open={open}
      onBackdropClick={onCancel}
    >
      {children}
    </Dialog>
  );
};
